import { ModuleType, PermissionType } from '../Api/ApiServerHooks';

// Classification saved positions belong to SUMΣC, but their permission is seeded under
// ModuleType.DataStandards. Screens that group permissions by module read the module through
// getPermissionModuleType, so it lands in the SUMΣC section instead of "Správce datových standardů".
const sumecPermissionTypes = new Set<PermissionType>([
    PermissionType.ShareClassificationSavedPositions,
]);

export const getPermissionModuleType = (permission: { permissionType?: PermissionType; moduleType?: ModuleType }) =>
    permission.permissionType !== undefined && sumecPermissionTypes.has(permission.permissionType)
        ? ModuleType.Sumec
        : permission.moduleType;
